<template>
  <div class="post-wrapper">
    <div id="viralPostResultCol" class="thumbnail">
      <div class="thumb">
        <img class="card-img-top" v-if="!post.media_url.includes('.mp4')" :src="post.media_url" />
        <video class="card-img-top" v-if="post.media_url.includes('.mp4')" :src="post.media_url" />

        <div class="caption-overflow" style="position: absolute;">
          <span>
            <button
              id="0"
              v-on:click="modal = true"
              class="btn border-white text-white btn-flat btn-icon btn-rounded waves-effect waves-effect"
            >
              <i class="fa fa-search-plus big-icon"></i>
            </button>
          </span>
        </div>
      </div>
      <div class="post-caption">
        <div class="card-text d-flex justify-content-around">
          <div class="post--likes">
            <mdb-tooltip trigger="hover" :options="{ placement: 'top' }">
              <span slot="tip">Number of likes</span>
              <i aria-hidden="true" class="far fa-heart"></i>
              <span class="ml-2" slot="reference">
                {{ post.like_count.toLocaleString() }}
                <i
                  class="far fa-question-circle text-muted small"
                ></i>
              </span>
            </mdb-tooltip>
          </div>
          <div class="post--comments">
            <mdb-tooltip trigger="hover" :options="{ placement: 'top' }">
              <span slot="tip">Number of comments</span>
              <i aria-hidden="true" class="far fa-heart"></i>
              <span class="ml-2" slot="reference">
                {{ post.comments_count.toLocaleString() }}
                <i
                  class="far fa-question-circle text-muted small"
                ></i>
              </span>
            </mdb-tooltip>
          </div>

          <div class="post--engagement">
            <mdb-tooltip trigger="hover" :options="{ placement: 'top' }">
              <span slot="tip">Engageremt rate (likes + comments / follower)</span>
              <i aria-hidden="true" class="far fa-heart"></i>
              <span class="ml-2" slot="reference">
                {{ engagementRate }} %
                <i class="far fa-question-circle text-muted small"></i>
              </span>
            </mdb-tooltip>
          </div>
        </div>
      </div>
    </div>

    <mdb-modal size="lg" :show="modal" @close="modal = false">
      <mdb-modal-header>
        <mdb-modal-title>Post details</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <div class="row">
          <div class="col-md-7">
            <div class="holder">
              <img
                class="card-img-top"
                v-if="!post.media_url.includes('.mp4')"
                :src="post.media_url"
              />
              <video
                class="card-img-top"
                v-if="post.media_url.includes('.mp4')"
                :src="post.media_url"
                id="igVideo"
              />
              <div
                v-if="post.media_url.includes('.mp4')"
                class="caption-overflow"
                style="position: absolute;"
              >
                <span>
                  <button
                    v-on:click="toggleVideo"
                    class="btn border-white text-white btn-flat btn-icon btn-rounded waves-effect waves-effect"
                  >
                    <i id="videoIcon" class="fa big-icon fa-play"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-md-6">
                <p>
                  <b>Likes</b>
                </p>
              </div>
              <div class="col-md-6">
                <p id="postDetailsLikes" class="pull-right">{{ post.like_count.toLocaleString() }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <p>
                  <b>Comments</b>
                </p>
              </div>
              <div class="col-md-6">
                <p
                  id="postDetailsComments"
                  class="pull-right"
                >{{ post.comments_count.toLocaleString() }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <p>
                  <b>Caption</b>
                </p>
              </div>
              <div class="col-md-12">
                <p id="postDetailsCaption">{{ post.caption }}</p>
              </div>
            </div>
            <div class="row" v-if="hashtags.length > 0">
              <div class="col-md-12">
                <p>
                  <b>
                    Tags
                    <span class="copy-btn" v-on:click="copyTags">copy</span>
                    <span class="small ml-2" v-if="copied">copied!</span>
                  </b>
                </p>
              </div>
              <div class="col-md-12">
                <div class="hashtags">
                  <div v-for="tag in hashtags" :key="tag">
                    <span>#{{ tag }}</span>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <a
              :href="post.permalink"
              id="postDetailsInstagramUrl"
              target="_blank"
              data-toggle="tooltip"
              data-placement="bottom"
              title
              class="btn btn-success waves-effect waves-light"
              style="width: 100%;"
              data-original-title="Show on instagram"
            >
              <i class="fab fa-instagram"></i> Show on instagram
            </a>
            <button
              type="button"
              data-toggle="tooltip"
              data-placement="bottom"
              title
              class="btn btn-primary waves-effect waves-light"
              style="width: 100%;"
              data-original-title="Download"
              v-on:click="save"
            >
              <i class="fa fa-download"></i> Download post
            </button>
            <!--<button
              type="button"
              data-toggle="tooltip"
              data-placement="bottom"
              title
              class="btn btn-purple waves-effect waves-light"
              style="width: 100%;"
              data-original-title="Add to favorites"
            >
              <i class="fa fa-heart"></i> Add to favorites
            </button>-->
          </div>
        </div>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn color="secondary" size="sm" @click.native="modal = false">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import {
  mdbTooltip,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn
} from "mdbvue";
export default {
  name: "InstagramPost",
  components: {
    mdbTooltip,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn
  },
  props: ["post", "follower"],
  data: function() {
    return {
      modal: false,
      copied: false
    };
  },
  methods: {
    save: function() {
      const url = this.post.media_url;
      const filename = url.substring(url.lastIndexOf("/") + 1).split("?")[0];
      const xhr = new XMLHttpRequest();
      xhr.responseType = "blob";
      xhr.onload = function() {
        let a = document.createElement("a");
        a.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
        a.download = filename; // Set the file name.
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a = null;
      };
      xhr.open("GET", url);
      xhr.send();
    },
    toggleVideo: function() {
      const video = document.getElementById("igVideo");
      const icon = document.getElementById("videoIcon");

      video.onpause = function() {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
      };
      //video.paused ? video.play() : video.pause();
      if (video.paused) {
        video.play();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
      } else {
        video.pause();
      }
    },
    copyTags: function() {
      const tags = this.hashtags;

      let tagsString = "";
      tags.forEach(tag => {
        tagsString += " #" + tag;
      });

      if (!navigator.clipboard) {
        // Clipboard API not available
        return;
      }
      try {
        navigator.clipboard.writeText(tagsString);
        this.copied = true;

        setTimeout(() => {
          this.copied = false;
        }, 1500);
      } catch (err) {
        console.error("Failed to copy!", err);
      }
    }
  },
  computed: {
    engagementRate: function() {
      return Number(
        (
          ((this.post.like_count + this.post.comments_count) / this.follower) *
          100
        ).toFixed(1)
      );
    },
    hashtags: function() {
      const tags = this.post.caption.split("#");
      tags.shift();
      return tags;
    }
  }
};
</script>
